const MenuBoardIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Closed elegant menu card */}
      <rect
        x="9"
        y="5"
        width="22"
        height="30"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      {/* Spine fold */}
      <path d="M14 5v30" stroke="currentColor" strokeWidth="1.5" opacity="0.4" />
      {/* Header line */}
      <path d="M18 12h9" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      {/* Menu rows */}
      <path d="M18 18h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18 23h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18 28h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Small wine glass accent */}
      <path
        d="M11.5 14.5c.9 0 1.5.7 1.5 1.6 0 1.4-1.5 2.6-1.5 2.6s-1.5-1.2-1.5-2.6c0-.9.6-1.6 1.5-1.6z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path d="M11.5 18.7v3.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M10.3 22h2.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
};

export default MenuBoardIcon;
